import type { PrimitiveSymbol3DModelKey } from "../registry/primitiveSymbol3DConfig";
import type { StandardSymbol3DAsset } from "./standardSymbol3DAssets";

export const STANDARD_SYMBOL_3D_ASSET_OVERRIDES = {} satisfies Partial<Record<PrimitiveSymbol3DModelKey, StandardSymbol3DAsset>>;
